export const IMAGE_MAX_BYTES = 2 * 1024 * 1024;
export const MAX_UPLOAD_FILE_SIZE = {
    READABLE: '25 MiB',
    VALUE: 25 * 1024 * 1024, // nginx considers mebibytes https://hg.nginx.org/nginx/file/default/src/core/ngx_parse.c
};

export const ROLES = {
    APP_USER: 'appUser',
    APP_MAKER: 'appMaker',
};

export const SEND_STATUS = {
    SENDING: 'sending',
    FAILED: 'failed',
    SENT: 'sent',
};

export const LOCATION_ERRORS = {
    PERMISSION_DENIED: 1,
    POSITION_UNAVAILABLE: 2,
    TIMEOUT: 3,
};

export const IMAGE_DISPLAY = {
    WIDE: 'wide',
    TALL: 'tall',
};

export const IMAGE_ASPECT_RATIO = {
    SQUARE: 'square',
    HORIZONTAL: 'horizontal',
};

export const GLOBAL_ACTION_TYPES = ['reply', 'locationRequest'];

export const MESSAGE_TYPES = {
    TEXT: 'text',
    IMAGE: 'image',
    LOCATION: 'location',
    FILE: 'file',
    CAROUSEL: 'carousel',
    LIST: 'list',
    FORM: 'form',
    FORM_RESPONSE: 'formResponse',
};

export const ACTION_TYPES = {
    LINK: 'link',
    BUY: 'buy',
    POSTBACK: 'postback',
    WEBVIEW: 'webview',
};

export const FORM_FIELD_TYPES = {
    TEXT: 'text',
    EMAIL: 'email',
    SELECT: 'select',
};

export const FORM_RESPONSE_FIELD_PROPS = ['label', 'name', 'type'];
